// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:24:19

export default {
  "id": "find-it-in-the-haunted-mansion",
  "slug": "find-it-in-the-haunted-mansion",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/19497ffef8f140e587c732f2128a86e3-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/19497ffef8f140e587c732f2128a86e3/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Find It In The Haunted Mansion",
      "description": "“Find It In The Haunted Mansion” is a finding style game, where you are a detective and need to find all the keys hidden in each part of the house to complete all the levels.",
      "instructions": "On mobile, use screen touch\nOn the computer, use the mouse.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "challenge",
        "find",
        "halloween",
        "horror"
      ]
    },
    "zh-CN": {
      "title": "在鬼屋中找到它",
      "description": "《在鬼屋中寻找》是一款寻宝风格的游戏，你扮演一名侦探，需要找到隐藏在房屋每个部分的全部钥匙，以完成所有关卡。",
      "instructions": "在手机上，使用屏幕触摸。\n在电脑上，使用鼠标。",
      "genres": [
        "拼图"
      ],
      "tags": [
        "1玩家",
        "挑战",
        "寻找",
        "万圣节",
        "恐怖"
      ]
    },
    "zh-TW": {
      "title": "在驚悚大宅中尋找它",
      "description": "“在幽靈古宅中尋找”是一款尋寶風格遊戲，你在遊戲中扮演一名偵探，需要尋找藏於屋內各處的所有鑰匙，以完成所有關卡。",
      "instructions": "在移動裝置上，使用螢幕觸控。\n在電腦上，使用滑鼠。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1 玩家",
        "挑戰",
        "尋找",
        "萬聖節",
        "驚悚"
      ]
    },
    "zh-HK": {
      "title": "在驚悚大廈中尋找",
      "description": "「在驚悚大宅中尋找」是一款尋找風格遊戲，你扮演一名侦探，需要尋找藏於房屋各處的所有鑰匙，以完成所有關卡。",
      "instructions": "手提電腦上，使用螢幕觸控\n電腦上，使用滑鼠。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "挑戰",
        "尋找",
        "萬聖節",
        "恐怖"
      ]
    },
    "ja": {
      "title": "幽霊の館でそれを見つけろ",
      "description": "「Find It In The Haunted Mansion」は、探しゲームスタイルで、あなたは探偵として家の各部分に隠された全ての鍵を見つけ、全てのレベルをクリアする必要があります。",
      "instructions": "モバイルでは、スクリーンタッチを使用してください。\nコンピュータでは、マウスを使用してください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "挑戦",
        "見つける",
        "ハロウィン",
        "ホラー"
      ]
    },
    "ko": {
      "title": "호스트하우스에서 찾아라",
      "description": "\"Find It In The Haunted Mansion\"은 탐색 스타일 게임으로, 당신은 탐정으로서 집의 각 부분에 숨겨진 모든 열쇠를 찾아 모든 레벨을 완료해야 합니다.",
      "instructions": "모바일에서는 스크린 탭 사용\n컴퓨터에서는 마우스 사용",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "도전",
        "찾기",
        "할로윈",
        "공포"
      ]
    },
    "fr": {
      "title": "Trouvez-le dans la maison hantée",
      "description": "\"Trouvez-le Dans la Maison Hantée\" est un jeu de recherche, où vous incarnez un détective et devez trouver toutes les clés cachées dans chaque partie de la maison pour terminer tous les niveaux.",
      "instructions": "Sur mobile, utilisez le toucher de l'écran.\nSur l'ordinateur, utilisez la souris.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "défi",
        "trouver",
        "Halloween",
        "horreur"
      ]
    }
  }
};
